import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { EchelonService } from 'src/app/services/echelon/echelon.service';
import { Router } from '@angular/router';
import {ChartWrapperComponent} from '../charts/chart-wrapper/chart-wrapper.component';
import { ToolboxModule } from '../toolbox.module';


import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes,
} from '@angular/animations';


//Echelon opening and closing
export const widthAnimation = trigger('widthAnimation', [
  state(
    'closed',
    style({
      width: '680px',
    })
  ),
  state(
    'open',
    style({
      width: '100%',
    })
  ),
  transition(
    'closed => open',
    animate(
      '500ms ease-in',
      keyframes([style({ width: '680px' }), style({ width: '100%'})])
    )
  ),
  transition(
    'open => closed',
    animate(
      '500ms ease-out',
      keyframes([style({ width: '100%' }), style({ width: '680px' })])
    )
  ),

]);

export const fade = trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300, style({ opacity: 1 }))
      ]),

    ])

@Component({
  selector: 'app-echelon',
  templateUrl: './echelon.component.html',
  styleUrls: ['./echelon.component.scss'],
  animations: [widthAnimation, fade],
  standalone: true,
  imports: [NgIf, NgFor, ChartWrapperComponent, ToolboxModule],
})
export class EchelonComponent {
  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    public auth: RxAuthService,
    private EchelonService: EchelonService,
    private router:Router,

  ) {}

  @ViewChild('echelonElement') echelonElement!: ElementRef;

  @Input() echelonType: any = '';
  @Input() retailer: any = '';
  @Input() rcl: any = '';
  @Input() showPadlock:boolean=false;

  @Input() turnOffInteractivity: boolean = false;
  startEchelonAnimation = false;
  showEchelonContent = false;
  showEchelon = false;

  EchelonData: Array<any> = [];
  currentVisualizations: Array<any> = [];

  ngOnInit() {

    this.getEchelonVisualizations();
    //Get data for current echelontype and irn in list
    //Call the relevant charts
  }

  showEchelonContentSwitch() {
    this.startEchelonAnimation = !this.startEchelonAnimation;

    setTimeout(() => {
      this.echelonElement?.nativeElement.scrollIntoView(true, {behavior:'smooth'})

    }, 500)

    if (this.showEchelonContent === false) {
      setTimeout(() => {
        this.showEchelonContent = !this.showEchelonContent;
      }, 500);
    } else {
      this.showEchelonContent = !this.showEchelonContent;




    }
  }

  getEchelonVisualizations() {
    this.EchelonService.getEchelonVisualizations(
      this.echelonType.id,
      this.rcl
    ).subscribe((response: any) => {

      this.EchelonData = response.data;

      this.currentVisualizations = response.current_visualizations
      this.showEchelon = true;
      
    });
  }
}
